import { Link } from "react-router-dom";
import { Icons } from "../../../../../../../shared/icons/icons";
import {
  buildWhatsAppLink,
  getWhatsAppMessageByKey,
} from "../../../../../../../shared/config/contact.config";

export default function ClinicActions({ content }) {
  const clinicWhatsAppMessage = getWhatsAppMessageByKey("clinic");
  const clinicWhatsAppLink = buildWhatsAppLink(clinicWhatsAppMessage);

  return (
    <div className="clinic-section__actions reveal-on-scroll reveal-on-scroll--up reveal-delay-3">
      <Link to="/space" className="clinic-btn clinic-btn--primary">
        <Icons.Camera />
        {content.button}
      </Link>

      <a
        href={clinicWhatsAppLink}
        target="_blank"
        rel="noreferrer"
        className="clinic-btn clinic-btn--secondary"
      >
        <Icons.Calendar />
        {content.secondaryButton || "Agendar atendimento"}
      </a>
    </div>
  );
}